
import { Component, Vue } from 'vue-property-decorator';
import CustomersAppUsersCreate from '@/pages/mycompany/appusers/Create.vue';

@Component({
  components: { CustomersAppUsersCreate }
})
export default class AppUsersCreate extends Vue {}
